import { Container, Row, Col } from "reactstrap";
import { useRouter } from "next/router";
import { JobSearchStandaloneWidget } from "@sourceflow-uk/job-search";
import Link from "next/link";
import BannerOverlay from "/public/site-assets/svg/banner-overlay.svg";
import styles from "./styles.module.scss";

export const JobsBanner = ({
  className,
  title,
  heading,
  titleColour,
  subTitle,
  content,
  image,
  popularCategories,
}) => {
  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  return (
    <section className={`${styles.root} ${className} pt-0`}>
      <Container>
        <Row className="m-0">
          <Col
            lg={9}
            xl={8}
            xxl={7}
            className="contentWrapper d-flex flex-wrap align-items-center position-relative"
          >
            <div className="w-100">
              {subTitle && (
                <h5 className="d-inline-block fw-bold text-primary border-bottom border-primary pb-3 mb-3">{subTitle}</h5>
              )}
              {title && (
                <h1
                  className={`text-${titleColour?.variant} ${heading}`}
                  style={titleColour?.custom ? { color: titleColour?.custom } : null}
                >
                  {title}
                </h1>
              )}
              {content && (
                <div
                  className="body lead mt-4 me-md-5 pe-md-5"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
              <JobSearchStandaloneWidget
                searchInput={{
                  queryInput: true,
                  locationInput: false,
                  radiusInput: false,
                }}
                submitDestination={`${locale ? locale : ""}jobs`}
                translations={{
                  "button.text": "Search",
                  "input.query.placeholder": "Job title, skills, or company...",
                }}
              />
              {popularCategories?.categories && popularCategories?.categories?.length > 0 &&
                <dl className="popularCategories d-flex flex-wrap align-items-center gap-3 m-0">
                  <dt className="m-0">{popularCategories?.title}:</dt>
                  {popularCategories?.categories.map((category, index) =>
                    <dd key={index} className="m-0 fw-light">
                      <Link href={category.href}>
                        <a>{category.label}</a>
                      </Link>
                    </dd>
                  )}
                </dl>
              }
            </div>
          </Col>
          <figure className="imageWrapper position-absolute p-0 m-0">
            {image?.url ? (
              <img
                src={image?.url ?? "/public/site-assets/svg/banner-overlay.svg"}
                alt={image?.alt ?? "Banner Image"}
                loading="eager"
                className="card-img rounded-0"
              />
            ) : (
              <BannerOverlay />
            )}
          </figure>
        </Row>
      </Container>
    </section>
  );
};

export default JobsBanner;
